/**
 * Tenants API Service
 */

import { apiClient } from "./client";
import type {
  CreateTenantDto,
  TenantPublicResponse,
  TenantWithSpace,
  UpdateTenantDto,
} from "@/types";

export const tenantsService = {
  async getPublicBySlug(slug: string): Promise<TenantPublicResponse> {
    return apiClient.get<TenantPublicResponse>(
      `/tenants/public/${encodeURIComponent(slug)}`,
    );
  },

  async getAll(): Promise<TenantWithSpace[]> {
    return apiClient.get<TenantWithSpace[]>("/tenants");
  },

  async getById(id: string): Promise<TenantWithSpace> {
    return apiClient.get<TenantWithSpace>(
      `/tenants/${encodeURIComponent(id)}`,
    );
  },

  async create(body: CreateTenantDto): Promise<TenantWithSpace> {
    return apiClient.post<TenantWithSpace>("/tenants", body);
  },

  async update(id: string, body: UpdateTenantDto): Promise<TenantWithSpace> {
    return apiClient.patch<TenantWithSpace>(
      `/tenants/${encodeURIComponent(id)}`,
      body,
    );
  },

  async delete(id: string): Promise<TenantWithSpace> {
    return apiClient.delete<TenantWithSpace>(
      `/tenants/${encodeURIComponent(id)}`,
    );
  },
};
